// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__2HMDA","logo":"Sidebar_logo__3HbBd","content":"Sidebar_content__1TqCb"};